import React from 'react'
import Flex from 'typescript-styled-flex'
import Expander from '../Expander'
import Text, { HeaderText } from '../Text'
import styled from '../../../theme'

const Container = styled.span`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 41;
  -webkit-box-orient: vertical;
`

export default function(notification, size = 1) {
  // const user = useSelector(getUserId)
  // const email = useSelector(getUserEmail)
  // const dispatch = useDispatch()
  // const { t } = useTranslation()
  let message = notification.details.exception

  if (notification.details.exception.length > 2055) {
    message = `${notification.details.exception.substring(0, 2055)}...`
  }

  // function action() {
  //   if (notification.sending !== 1 && notification.sending !== 2) {
  //     dispatch(
  //       sendErrorNotificationMessage(
  //         'booking_sync_errors@bed-booking.com',
  //         'BOOKING SYNC ERROR',
  //         `User ID: ${user}\n` +
  //           `Email: ${email}\n` +
  //           `Error message: ${notification.details.exception}\n\n` +
  //           `Job Payload: \n` +
  //           `${notification.details.payload} \n \n`,
  //         notification.id,
  //       ),
  //     )
  //   }
  // }

  return (
    <Expander size={size} id={notification.id} label={notification.subtitle}>
      <Text size={size}>
        <HeaderText size={size}>
          <Flex row={true} justifyBetween={true} alignStart={true}>
            {notification.message}
            {/*<ActionButton*/}
            {/*  size={size}*/}
            {/*  style={{ marginTop: 0, paddingLeft: `${10 * size}px` }}*/}
            {/*  label={*/}
            {/*    notification.sending === 2*/}
            {/*      ? t('BBO_3136_sent')*/}
            {/*      : notification.actionLabel*/}
            {/*  }*/}
            {/*  sending={notification.sending}*/}
            {/*  action={action}*/}
            {/*/>*/}
          </Flex>
        </HeaderText>
        <Container dangerouslySetInnerHTML={{ __html: message }} />
      </Text>
    </Expander>
  )
}
